import { motion } from 'framer-motion';
export default function Bottom(){
    const pstyle={
        color:"white",
        fontSize:"1.3em",
        paddingLeft:"20px",
        fontWeight:"200"
    }
    return <>
    <motion.div style={{paddingLeft:"20px",margin:"20px"}}
    initial={{
        x:-40,
        opacity:0
    }}
    animate={{
        x:0,
        opacity:1
    }}
    transition={{
        duration:0.7,
        delay:1.35
    }}
    >
      <i class="fa-solid fa-cake-candles" style={{color: "#fc8755" , fontSize:"1.2rem"}}></i>
      <span style={pstyle}>26 Feb 2003</span>
    </motion.div>
    <motion.div 
    initial={{
        x:-40,
        opacity:0
    }}
    animate={{
        x:0,
        opacity:1
    }}
    transition={{
        duration:0.7,
        delay:1.65
    }}
    style={{paddingLeft:"20px",margin:"20px"}}>
    <i class="fa-solid fa-mobile-screen-button" style={{color: "#fc8755" , fontSize:"1.2rem"}}></i>
      <span style={pstyle}>+91 7478856289</span>
    </motion.div>


    <motion.div 
    initial={{
        x:-40,
        opacity:0
    }}
    animate={{
        x:0,
        opacity:1
    }}
    transition={{
        duration:0.7,
        delay:1.95
    }}
    style={{paddingLeft:"20px",margin:"20px"}}>
    <i class="fa-regular fa-envelope"  style={{color: "#fc8755" , fontSize:"1.2rem"}}></i>
      <span style={pstyle}>ankit.kum.sha9933@gmail.com</span>
    </motion.div>


    <motion.div 
    initial={{
        x:-40,
        opacity:0
    }}
    animate={{
        x:0,
        opacity:1
    }}
    transition={{
        duration:0.7,
        delay:2.25
    }}
    style={{paddingLeft:"20px",margin:"20px"}}>
    <i class="fa-solid fa-house-chimney"  style={{color: "#fc8755" , fontSize:"1.2rem"}}></i>
      <span style={pstyle}>West Bengal, India</span>
    </motion.div>
    </>
}